import { Col, Container, Row } from "react-bootstrap";
import Skeleton from "react-loading-skeleton";

const OnlineAuctionSkeleton = () => {
  return (
    <div className="page h-100 pb-3">
      <Container>
        <Row>
          <Col md={5}>
            <div className="mt-15 h-100 w-100 mb-15 d-none d-md-block">
              <Skeleton height="94%" width="100%" />
            </div>
          </Col>
          <Col md={7}>
            <div className="mt-15">
              <div className="mt-13">
                <Skeleton height="350px" width="100%" />
              </div>

              <div style={{ marginTop: "20px" }}>
                <Skeleton height="150px" width="100%" />
              </div>
            </div>
          </Col>
        </Row>
      </Container>

      <Container>
        <Row>
          <Col md="12">
            <div style={{ marginTop: "20px" }}>
              <Skeleton height="100px" width="100%" />
            </div>
          </Col>
        </Row>
      </Container>

      <Container>
        <div style={{ marginTop: "20px" }}>
          <Skeleton height="250px" width="100%" />
        </div>
      </Container>
    </div>
  )
}
export default OnlineAuctionSkeleton;